(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["site-header-height"] && !Shopify.designMode) return;
  try {
    (function () {
    var HEADER_SELECTOR = '.header';

    function syncSiteHeaderHeight() {
      var header = document.querySelector(HEADER_SELECTOR);
      if (!header) return;
      document.documentElement.style.setProperty(
        '--site-header-height',
        header.offsetHeight + 'px'
      );
    }

    function init() {
      syncSiteHeaderHeight();

      if (typeof ResizeObserver !== 'undefined') {
        var header = document.querySelector(HEADER_SELECTOR);
        if (header && !header.dataset.siteHeaderHeightObserved) {
          var observer = new ResizeObserver(syncSiteHeaderHeight);
          observer.observe(header);
          header.dataset.siteHeaderHeightObserved = 'true';
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    window.addEventListener('resize', syncSiteHeaderHeight);
    document.addEventListener('shopify:section:load', syncSiteHeaderHeight);
    document.addEventListener('shopify:section:unload', syncSiteHeaderHeight);
    document.addEventListener('shopify:section:reorder', syncSiteHeaderHeight);
  })();
  } catch(e) { console.error(e); }
})();

})();
